// Targets API
import { api } from './client';

export const targetsAPI = {
  getByProject: (projectId: number) => {
    console.log('🎯 Fetching targets for project:', projectId);
    return api.get(`/project/${projectId}/targets`);
  },
  create: (projectId: number, data: any) => {
    console.log('➕ Creating target for project:', projectId, data);
    return api.post(`/project/${projectId}/targets`, data);
  },
  bulkCreate: (projectId: number, targets: any[]) => {
    console.log('📦 Bulk creating targets for project:', projectId, `${targets.length} targets`);
    return api.post(`/project/${projectId}/targets/bulk`, { targets });
  },
  update: (id: number, data: any) => {
    console.log('📝 Updating target:', id, data);
    return api.put(`/targets/${id}`, data);
  },
  delete: (id: number) => {
    console.log('🗑️ Deleting target:', id);
    return api.delete(`/targets/${id}`);
  },
  expandTarget: async (targetId: number) => {
    console.log('🔍 Expanding target:', targetId);
    const response = await api.get(`/targets/${targetId}/expand`);
    return response.data;
  },
  checkDuplicates: (projectId: number, targets: string[]) => {
    console.log('🔍 Checking for duplicate targets:', targets.length);
    return api.post(`/project/${projectId}/targets/check-duplicates`, { targets });
  },
  bulkDelete: (projectId: number, targetIds: number[]) => {
    console.log('🗑️ Bulk deleting targets:', targetIds.length);
    return api.post(`/project/${projectId}/targets/bulk-delete`, { target_ids: targetIds });
  },
  bulkTag: (projectId: number, targetIds: number[], tag: string, action: 'add' | 'remove' = 'add') => {
    console.log(`🏷️ Bulk ${action} tag "${tag}" on`, targetIds.length, 'targets');
    return api.post(`/project/${projectId}/targets/bulk-tag`, { target_ids: targetIds, tag, action });
  },
  expandRangePreview: (projectId: number, address: string, type: 'range' | 'cidr') => {
    console.log('🔍 Previewing IP range expansion:', address);
    return api.post(`/project/${projectId}/targets/expand-preview`, { address, type });
  },
  getStats: (projectId: number) => {
    console.log('📊 Fetching target stats for project:', projectId);
    return api.get(`/project/${projectId}/targets/stats`);
  },
  resolveTarget: (projectId: number, targetId: number) => {
    console.log('🔍 Resolving target:', targetId);
    return api.post(`/project/${projectId}/targets/${targetId}/resolve`);
  },
  getDeadTargets: (projectId: number, days?: number) => {
    console.log('💀 Fetching dead targets for project:', projectId);
    const params = days ? `?days=${days}` : '';
    return api.get(`/project/${projectId}/targets/dead${params}`);
  },
  cleanupDeadTargets: (projectId: number, daysThreshold: number, action: 'delete' | 'archive') => {
    console.log('🧹 Cleaning up dead targets:', action);
    return api.post(`/project/${projectId}/targets/cleanup-dead`, { days_threshold: daysThreshold, action });
  },

  // Alias management (hostname aliases on IP targets)
  getAliases: (targetId: number) => {
    console.log('📋 Fetching aliases for target:', targetId);
    return api.get(`/targets/${targetId}/aliases`);
  },
  addAlias: (targetId: number, hostname: string) => {
    console.log('➕ Adding alias to target:', targetId, hostname);
    return api.post(`/targets/${targetId}/aliases`, { hostname });
  },
  updateAlias: (targetId: number, oldHostname: string, newHostname: string) => {
    console.log('📝 Updating alias on target:', targetId, oldHostname, '->', newHostname);
    return api.put(`/targets/${targetId}/aliases`, { old_hostname: oldHostname, new_hostname: newHostname });
  },
  removeAlias: (targetId: number, hostname: string) => {
    console.log('🗑️ Removing alias from target:', targetId, hostname);
    return api.delete(`/targets/${targetId}/aliases`, { data: { hostname } });
  },
  reResolveHostname: (targetId: number) => {
    console.log('🔄 Re-resolving hostname target:', targetId);
    return api.post(`/targets/${targetId}/re-resolve`);
  },

  // Target usage (count vs subscription limit)
  getUsage: () => {
    return api.get('/targets/usage');
  },

  // Export targets report
  exportReport: (projectId: number, format: 'html' | 'excel' | 'csv' | 'json', language?: string) => {
    console.log(`📤 Exporting targets report for project ${projectId} as ${format}`);
    const params = new URLSearchParams({ format });
    if (language) params.append('language', language);
    return api.get(`/project/${projectId}/targets/export?${params}`, {
      responseType: format === 'json' ? 'json' : 'blob'
    });
  },
};
